import React, { useState } from "react";
import i18n from "i18next";
import classnames from "classnames";
import Button from "~/Common-Objects/UI/Forms/Button/Button";

export default function DeleteCdnDomain({
  domain,
  className,
  onDelete,
  onDeleted,
  ...rest
}) {
  const [deleting, setDeleting] = useState(false);

  async function handleDelete() {
    setDeleting(true);

    try {
      await onDelete(domain);
      onDeleted && onDeleted();
    } finally {
      setDeleting(false);
    }
  }

  const classes = classnames("delete-domain", className);

  return (
    <div className={classes} {...rest}>
      <h2 className="h4 mar-b15">{i18n.t("company:domains.cdn.delete")}</h2>

      <p>{i18n.t("company:domains.cdn.deleteConfirm")}</p>


      <Button
        className="button-red"
        saving={deleting}
        onClick={handleDelete}
      >
        {i18n.t("company:domains.deleteButton")}
      </Button>
    </div>
  );
}
